<template>
  <div ref="component" class="simple deng">
    <div class="set-container">
      <div class="set-item">
        <span class="title" :class="inMapSet ? 'set-title': ''">字体</span>
        <div class="content">
          <el-select :style="{height: '32px', width: '100%', '--fontFamily': fontFamilyVal}" v-model="fontFamilyVal"  popper-class="font-families"  class="font-family-select">
            <el-option
              v-for="(item, index) in fontFamilyList"
              :key="index"
              :selected="fontFamilyVal == item.value"
              :value="item.value"
              :label="item.title"
              ><img :src="item.img" class="font-family-img" />
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="set-item">
        <span class="title" :class="inMapSet ? 'set-title': ''">字重</span>
        <div class="content">
          <el-select v-model="fontWeightVal" class="content-item" style="width: 100%;">
            <el-option
              v-for="(item, index) in currentFontWeightList"
              :key="index"
              :selected="fontWeightVal == item.value"
              :value="item.value"
              :label="item.title"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="set-item">
        <span class="title"  :class="inMapSet ? 'set-title': ''">颜色</span>
        <div class="content">
         <div class="color-picker-container flex1" v-if="colorMode==='chart'">
                        <el-color-picker
                          :popper-append-to-body="false"
                          v-model="fontColorVal"
                          :show-alpha="true"
                          :predefine="predefineColors"
                          @active-change="activeChangeColor"></el-color-picker>
            <span class="floatLeft color-text mr8">{{ fontColorVal }}</span>
          </div>
          <cx-color-picker
            v-else-if="colorMode==='simple'"
            class="flex-box"
            :colorArr.sync="fontColorVal"
          >
          </cx-color-picker>
          <cx-color-picker
              v-else
              class="custom-text-bg flex-box"
              :isThemeColor.sync="isThemeColorVal"
              :colorArr.sync="colorArrVal"
              :activeName.sync="activeNameColorVal"
              :showSecondTab="false"
            >
            </cx-color-picker>
          <!-- <el-color-picker
            :popper-append-to-body="false"
            v-model="fontColorVal"
            :show-alpha="true"
            :predefine="predefineColors"
            @active-change="activeChangeColor"
          ></el-color-picker> -->
        </div>
      </div>
      <div class="set-item">
        <span class="title"  :class="inMapSet ? 'set-title': ''">字号</span>
        <div class="content  font-flex-content">
          <single-input style="width: 88px" :value.sync="originFontSizeVal" inputSuffixs="px" />
          <div class="btn-wrapper">
            <span
              :class="originFontSizeVal === 0 ? 'disabled num-btn icon-portal-minus' : 'num-btn icon-portal-minus'"
              @click="originFontSizeVal--"
            ></span>
            <span :class="'num-btn icon-portal-plus'" @click="originFontSizeVal++"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../common.css"
import publicData from "../mixins/publicData.js"

export default {
  mixins: [ publicData],
  name: "textSettingUpdate",
  props: {
    textIsThemeColor: Boolean,
    colorArr: undefined,
    activeNameColor: undefined,
    inMapSet: {
      type: Boolean,
      default: false
    },
    fontWeight: {
      type: [String, Number],
      required: true
    },
    fontSize: {
      type: Number,
      required: true
    },
    fontFamily: {
      type: String,
      required: true
    },
    fontColor: {
      type: [String, Object],
      required: true
    },
    isThemeColor: {
      type: Boolean,
      default: false
    },
    colorMode: {
      type: String,
      default: "simple"      
    }
  },
  data() {
    return {
      // fontSizeVal:0,
      fontFamilyList: [
        {
          title: "默认字体",
          value: "sans-serif",
          img: require(`@/assets/images/fontImages/默认字体${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "细体",
              value: 200
            },
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            },
            {
              title: "加粗体",
              value: 900
            }
          ]
        },
        {
          label: "钉钉进步体",
          value: "钉钉进步体",
          img: require(`@/assets/images/fontImages/钉钉进步体${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "细体",
              value: 200
            },
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            },
            {
              title: "加粗体",
              value: 900
            }
          ]
        },
        {
          title: "方正清刻本悦宋简体",
          value: "方正",
          img: require(`@/assets/images/fontImages/方正清刻本悦宋简体${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "细体",
              value: 200
            },
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            },
            {
              title: "加粗体",
              value: 900
            }
          ]
        },
        {
          title: "方正正大黑简体",
          value: "方正正大黑简体",
          img: require(`@/assets/images/fontImages/方正正大黑简体${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "细体",
              value: 200
            },
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            },
            {
              title: "加粗体",
              value: 900
            }
          ]
        },
        {
          label: "联想小新潮酷体",
          value: "联想小新潮酷体",
          img: require(`@/assets/images/fontImages/联想小新潮酷体${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "细体",
              value: 200
            },
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            },
            {
              title: "加粗体",
              value: 900
            }
          ]
        },
        {
          title: "庞门正道标题体",
          value: "庞门正道标题",
          img: require(`@/assets/images/fontImages/庞门正道标题体${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "细体",
              value: 200
            },
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            },
            {
              title: "加粗体",
              value: 900
            }
          ]
        },
        {
          title: "思源黑体",
          value: "SourceHanSansCN",
          img: require(`@/assets/images/fontImages/思源黑体${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "细体",
              value: 200
            },
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            },
            {
              title: "加粗体",
              value: 900
            }
          ]
        },
        {
          title: "思源宋体",
          value: "SourceHanSerifCN",
          img: require(`@/assets/images/fontImages/思源宋体${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "细体",
              value: 200
            },
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            },
            {
              title: "加粗体",
              value: 900
            }
          ]
        },
        {
          title: "优设标题黑",
          value: "YouSheBiaoTiHei",
          img: require(`@/assets/images/fontImages/优设标题黑${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "常规体",
              value: 400
            }
          ]
        },
        {
          title: "Alata",
          value: "Alata",
          img: require(`@/assets/images/fontImages/Alata${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "常规体",
              value: 400
            }
          ]
        },
        {
          title: "D-din",
          value: "D-din",
          img: require(`@/assets/images/fontImages/D-din${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            }
          ]
        },
        {
          title: "D-din Condensed",
          value: "D-din Condensed",
          img: require(`@/assets/images/fontImages/D-DIN-Condensed${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            }
          ]
        },
        {
          title: "D-din Exp",
          value: "D-din Exp",
          img: require(`@/assets/images/fontImages/D-DIN-Exp${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            }
          ]
        },
        {
          title: "Raleway",
          value: "Raleway",
          img: require(`@/assets/images/fontImages/Raleway${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "细体",
              value: 200
            },
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            },
            {
              title: "加粗体",
              value: 900
            }
          ]
        },
        {
          label: "Roboto-Regular",
          value: "Roboto-Regular",
          img: require(`@/assets/images/fontImages/Roboto-Regular${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "细体",
              value: 200
            },
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            },
            {
              title: "加粗体",
              value: 900
            }
          ]
        },
        {
          label: "Roboto-Black",
          value: "Roboto-Black",
          img: require(`@/assets/images/fontImages/Roboto-Black${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "细体",
              value: 200
            },
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            },
            {
              title: "加粗体",
              value: 900
            }
          ]
        }
      ],
      fontWeightList: [
        {
          title: "细体",
          value: 200
        },
        {
          title: "常规体",
          value: 400
        },
        {
          title: "粗体",
          value: 700
        },
        {
          title: "加粗体",
          value: 900
        }
      ]
    }
  },
  // watch:{
  //   ids: {
  //     handler: function (newVal, oldVal) {
  //       this.fontSizeVal = this.originFontSizeVal
  //     },
  //     immediate: true,
  //     deep: true
  //   },
  //   originFontSizeVal(newVal, oldVal){
  //     if (newVal !== oldVal) {
  //       this.fontSizeVal = newVal
  //     }
  //   },
  // },
  mounted(){
    // this.fontSizeVal = this.originFontSizeVal
  },
  computed: {
    fontWeightMap() {
      const fontWeightMap = this.fontFamilyList.reduce((total, now) => {
        const { value, fontWeightList } = now
        total[value] = fontWeightList
        return total
      }, {})
      return fontWeightMap
    },
    currentFontWeightList() {
      return this.fontWeightMap[this.fontFamilyVal] || this.fontWeightList
    },
    fontWeightVal: {
      get() {
        return this.fontWeight
      },
      set(val) {
        this.$emit("update:fontWeight", val)
      }
    },
    originFontSizeVal: {
      get() {
        return this.fontSize
      },
      set(val) {
        this.$emit("update:fontSize", Number(val))
      }
    },
    fontFamilyVal: {
      get() {
        return this.fontFamily || "sans-serif"
      },
      set(val) {
        this.$emit("update:fontFamily", val)
      }
    },
    isThemeColorVal: {
      get() {
        return this.isThemeColor
      },
      set(val) {
        this.$emit("update:isThemeColor", val)
      }
    },
    activeNameColorVal: {
      get() {
        return this.activeNameColor
      },
      set(val) {
        this.$emit("update:activeNameColor", val)
      }
    },
    fontColorVal: {
      get() {
        return this.fontColor
      },
      set(val) {
        this.$emit("update:fontColor", val)
      }
    },
    isThemeColorVal: {
      get() {
        return this.isThemeColor
      },
      set(val) {
        this.$emit("update:isThemeColor", val)
      }
    },
    colorArrVal: {
      get() {
        return this.colorArr
      },
      set(val) {
        this.$emit("update:colorArr", val)
      }
    },
    activeNameColorVal: {
      get() {
        return this.activeNameColor
      },
      set(val) {
        this.$emit("update:activeNameColor", val)
      }
    },
  },
  watch: {
    fontFamilyVal(val) {
      const currentWeightList = this.fontWeightMap[val]
      if (currentWeightList?.length && !currentWeightList.some(item => item.value === this.fontWeightVal)) {
        this.fontWeightVal = currentWeightList[0].value
      }
    }
  },
  methods: {
    // getFocus(event) {
    //   event.currentTarget.select()
    // },
    activeChangeColor(val) {
      this.fontColorVal = val
    },
    // setValue(originName,name){
    //   if(this[name]){
    //     this[originName] = Number(this[name])
    //   }else{
    //     // 不允许输入为空 为空的情况恢复原来的值
    //     this[name] = Number(this[originName])
    //   }
    // }
  }
}
</script>
<style lang="scss" scoped>
.set-container {
  .set-item {
    display: flex;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 8px;
    .title {
      width: 32px;
      margin-right: 12px;
      line-height: 32px;
      font-size: 14px;
      font-weight: 400;
      text-align: left;
      &.set-title {
        width: 56px;
      }
    }
    .content {
      flex: 1;
      overflow: hidden;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}
.checkbox_colorPicker_container {
  height: 32px;
}
.font-flex-content {
  display: flex;
  gap: 8px;
  .font-arrangement-btn {
    flex: 1;
  }
}
.more-setting {
  display: flex;
  height: 24px;
  user-select: none;
  cursor: pointer;
  margin-bottom: 8px;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.6);
  background: rgba(233, 233, 233, 1);
  border-radius: 4px;
  gap: 4px;
  &:last-child {
    margin-bottom: 0;
  }
}
.btn-wrapper {
  background-color: var(--inputBg);
  border-radius: 4px;
  padding: 6px 0;
  font-size: 0;
  flex: 1;
  .num-btn {
    display: inline-block;
    width: 50%;
    text-align: center;
    line-height: 20px;
    font-size: 16px;
    cursor: pointer;
    &:not(:last-child) {
      border-right: 1px solid var(--sliderBackGround);
    }
    &:not(.disabled):hover {
      color: var(--themeColor);
    }
    &.disabled {
      color: var(--borderColorSeven);
      cursor: not-allowed;
      pointer-events: none;
    }
  }
}
::v-deep .font-family-select .el-input__inner {
  font-family: var(--fontFamily);
}
</style>
<style scoped>
.percent42 {
  width: 42%;
}
.width72 {
  width: 72px;
}
</style>
<style>
.font-families .el-select-dropdown__item {
  padding: 0;
  overflow: hidden;
}
.font-family-img {
  display: inline-block;
  width: 174px;
  height: 38px;
  width: auto;
}
.el-select-dropdown.font-families {
  transform: translate(-10px, 0);
}
</style>
